import { createSelector } from "reselect";

const patientsSelector = ({ patients }) => patients;

export const getPatientsArray = createSelector(
  patientsSelector,
  ({ patientsReducer }) => {
    return patientsReducer.patientsArray;
  }
);